import React, { useEffect, useState } from 'react'
import { 
  Card, CardBody, 
  Button,
  Input, Label, FormGroup
} from 'reactstrap'
import _ from 'lodash'

import MultilingualInput from 'components/MultiLangInput/v2'
import LoadingOverlay from 'components/Indicator/LoadingOverlay'
import Lang from 'Lang/General'
import HOC from './action'
import { DefaultFormValue } from './assets'

function ExpoMagazine(props) {
  const [formData, setFormData] = useState({
    ...DefaultFormValue,
    email: props.selectedPortalUsers.email || ''
  })
  
   useEffect(() => {
    if ( !_.isEmpty( props.selectedPortalUsers )) {
      props.getSelectedExpoMagazine(props.selectedPortalUsers.id )
    }
  }, [props.selectedPortalUsers])
  
  useEffect(() => {
    if ( !_.isEmpty( props.selectedExpoMagazine )) {
      setFormData({
        ...props.selectedExpoMagazine,
        email: props.selectedExpoMagazine.email || props.selectedPortalUsers.email
      })
    }
  }, [props.selectedExpoMagazine])

  return (
    <>
      <Card className={'mt-4'}>
        <CardBody>
          <h5>{Lang['EXPO_MAGAZINE'][props.data.languageReducer.userSettings.admin_panel_language]}</h5>
          <hr />
          <FormGroup>
            <Label>
              {Lang['COMPANY_NAME'][props.data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={ formData.company_name }
              onChange={ e => setFormData({
                ... formData,
                company_name: e.target.value
              })}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['WEBSITE_ADDRESS'][props.data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={ formData.website_address }
              onChange={ e => setFormData({
                ... formData,
                website_address: e.target.value
              })}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['CONTACT_PERSON'][props.data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={ formData.contact_person }
              onChange={ e => setFormData({
                ... formData,
                contact_person: e.target.value
              })}
            />
          </FormGroup>
          <FormGroup>
            <Label>
              {Lang['MAIL_ADDRESS'][props.data.languageReducer.userSettings.admin_panel_language]}
            </Label>
            <Input
              value={ formData.email }
              onChange={ e => setFormData({
                ... formData,
                email: e.target.value
              })}
            />
          </FormGroup>
          <MultilingualInput
            isTextArea
            maxLength={100}
            label={ Lang[ 'SHORT_DESC' ][ props.data.languageReducer.userSettings.admin_panel_language ] }
            selectedLanguage={ props.data.languageReducer.userSettings.admin_panel_language }
            value={ formData.short_description }
            valueName='short_description'
            parent={ formData }
            onChangeValue={ ( parentName, formDataValue ) => setFormData( formDataValue ) } 
          />
        </CardBody>
      </Card>
      <Card className={'mt-3 mb-2'}>
        <CardBody>
          <h5>{Lang['TEASER'][props.data.languageReducer.userSettings.admin_panel_language]}</h5>
          <hr />
          <MultilingualInput
            label={ Lang[ 'HEADLINE' ][ props.data.languageReducer.userSettings.admin_panel_language ] }
            selectedLanguage={ props.data.languageReducer.userSettings.admin_panel_language }
            value={ formData.teaser_headline }
            valueName='teaser_headline'
            parent={ formData }
            onChangeValue={ ( parentName, formDataValue ) => setFormData( formDataValue ) } 
          />
          <MultilingualInput
            isTextArea
            label={ Lang[ 'SHORT_DESC' ][ props.data.languageReducer.userSettings.admin_panel_language ] }
            selectedLanguage={ props.data.languageReducer.userSettings.admin_panel_language }
            value={ formData.teaser_short_description }
            valueName='teaser_short_description'
            parent={ formData }
            onChangeValue={ ( parentName, formDataValue ) => setFormData( formDataValue ) } 
          />
          <small className="d-block mb-3">
            {Lang['FEX_ALERT_MSG'][props.data.languageReducer.userSettings.admin_panel_language]}
          </small>
          <div className="d-flex">
            <Button 
              color={'primary'}
              className={'ml-auto'}
              onClick={() => {
                props.selectedExpoMagazine === null
                  ? props.createExpoMagazine({
                    ... formData,
                    user_id: props.selectedPortalUsers.id
                  })
                  : props.updateExpoMagazine({
                    ... formData
                  })
              }}
            >
              {Lang['SAVE'][props.data.languageReducer.userSettings.admin_panel_language]}
            </Button>
          </div>
        </CardBody>
      </Card>
      {
        props.onLoadExpoMagazine && <LoadingOverlay/>
      }
    </>
  )
}

export default HOC(ExpoMagazine)